import axios from 'axios';
import API_URL from './baseURL';

const auth = (token) => ({
  headers: { Authorization: `Bearer ${token || localStorage.getItem('authToken')}` },
});

export const listDevices = async (token) => {
  const res = await axios.get(`${API_URL}/telematics/devices`, auth(token));
  return res.data?.data?.devices || [];
};

export const linkDevice = async (payload, token) => {
  // payload: { imei, vehicleId, simNumber, carrier, installOdometerKm }
  const res = await axios.post(`${API_URL}/telematics/devices`, payload, auth(token));
  return res.data?.data?.device;
};

export const unlinkDevice = async (id, token) => {
  const res = await axios.patch(`${API_URL}/telematics/devices/${id}/unlink`, {}, auth(token));
  return res.data?.data?.device;
};

export const simulateCrash = async ({ vehicleId, side, severity }, token) => {
  const res = await axios.post(`${API_URL}/telematics/simulate-crash`, { vehicleId, side, severity }, auth(token));
  return res.data?.data?.event;
};

export const searchVehicleByPlate = async (plate, token) => {
  const res = await axios.get(`${API_URL}/vehicles/search`, { ...auth(token), params: { plate } });
  return res.data; // { found: boolean, vehicle?: { _id, plateNumber, brand, model, ... } }
};
